module.exports = require('./lib/chai');



//////////////////
// WEBPACK FOOTER
// ./~/chai/index.js
// module id = 1007
// module chunks = 168707334958949